module.exports = __webpack_public_path__ + "img/logo2.6fe47782.png";